import { defineComponent as _defineComponent } from 'vue'
import { useVerticalSwipe } from "@/composables/shared/useVerticalSwipe";
import { useDeviceStore } from "@/stores/deviceStore";
import { storeToRefs } from "pinia";

import { watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ExpandableModal',
  props: {
  swipeThreshold: {
    type: Number,
    default: 60,
  },
  animationDuration: {
    type: Number,
    default: 300,
  },
  maxHeightPx: {
    type: Number,
    default: window.innerHeight * 0.8,
  },
  baseHeightPx: {
    type: Number,
    default: 165,
  },
},
  emits: ["onToggleExpanded", "onContentHeightChange"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const { isShowingKeyboard } = storeToRefs(useDeviceStore());

// 임계값과 최대 높이를 props에서 가져와서 설정
const {
  containerStyle,
  onTouchStart,
  onTouchMove,
  onTouchEnd,
  swipedUp,
  setExpanded,
  setContentHeight,
} = useVerticalSwipe(
  props.swipeThreshold,
  props.maxHeightPx,
  true,
  props.baseHeightPx
);

const handleClickIndicator = () => {
  const newExpandedState = !swipedUp.value;
  setExpanded(newExpandedState);
};

const handleBackdropClick = () => {
  setExpanded(false);
};

const handleContentHeightChange = (height: number) => {
  setContentHeight(height);
  emit("onContentHeightChange", height);
};

watch(swipedUp, (newValue) => {
  emit("onToggleExpanded", newValue);
});

__expose({
  swipedUp,
  setExpanded,
  handleContentHeightChange,
});

const __returned__ = { props, emit, isShowingKeyboard, containerStyle, onTouchStart, onTouchMove, onTouchEnd, swipedUp, setExpanded, setContentHeight, handleClickIndicator, handleBackdropClick, handleContentHeightChange }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})